import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import infografia1 from '../assets/infografia1.png';
import infografia2 from '../assets/infografia2.png';
import infografia3 from '../assets/infografia3.png';
import infografia4 from '../assets/infografia4.png';
import infografia5 from '../assets/infografia5.png';
import infografia6 from '../assets/infografia6.png';
import infografia7 from '../assets/infografia7.png';


import Aux from '../hoc/auxi';

import 'bootstrap/dist/css/bootstrap.css';

class homepage extends Component {
    render() {
        let participate = (
            <div className="container text-center col-6 mb-5">
                    <div style={{ display: "inline" }}>
                        <Link to="/login">
                            <button className="btn btn-lg btn-primary mt-5 text-white ml-5 mr-5 mb-5" style={{ width: "200px" }} type="submit"><FormattedMessage id="login" /></button>
                        </Link>
                    </div>
                    <div style={{ display: "inline" }}>
                        <Link to="/register">
                            <button className="btn btn-lg btn-primary mt-5 text-white ml-5 mr-5 mb-5" style={{ width: "200px" }} type="submit"><FormattedMessage id="register-button" /></button>
                        </Link>
                    </div>
            </div>
        );

        if (this.props.isAuth)
            participate = null;

        return (
            <Aux>
                {/* <img src={Header} style={{ width: "100%", position:"relative" }} alt="header" /> */}
                <div className="container col-10 mt-5">
                    <h1 className="text-primary font-weight-normal"><FormattedMessage id="welcome-title" /></h1>
                    <p className="mt-3" ><FormattedMessage id="welcome-first-paragraph" /></p>
                </div>
                {participate}
                <div className="container col-9 text-center">
                    <div id="demo" className="carousel slide" data-ride="carousel">

                        {/*Indicators*/}
                        <ul className="carousel-indicators">
                            <li data-target="#demo0" data-slide-to="0" className="active"/>
                            <li data-target="#demo1" data-slide-to="1"/>
                            <li data-target="#demo2" data-slide-to="2"/>
                            <li data-target="#demo3" data-slide-to="3"/>
                            <li data-target="#demo4" data-slide-to="4"/>
                            <li data-target="#demo5" data-slide-to="5"/>
                            <li data-target="#demo6" data-slide-to="6"/>
                            <li data-target="#demo7" data-slide-to="7"/>
                        </ul>

                         {/*The slideshow*/}
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img src={infografia1} alt="infografia1"/>
                            </div>
                            <div className="carousel-item">
                                <img src={infografia2} alt="infografia2"/>
                            </div>
                            <div className="carousel-item">
                                <img src={infografia3} alt="infografia3"/>
                            </div>
                            <div className="carousel-item">
                                <img src={infografia4} alt="infografia4"/>
                            </div>
                            <div className="carousel-item">
                                <img src={infografia5} alt="infografia5"/>
                            </div>
                            <div className="carousel-item">
                                <img src={infografia6} alt="infografia6"/>
                            </div>
                            <div className="carousel-item">
                                <img src={infografia7} alt="infografia7"/>
                            </div>
                        </div>

                        {/*Left and right controls*/}
                        <a className="carousel-control-prev" href="#demo" data-slide="prev">
                            <span className="carousel-control-prev-icon"/>
                        </a>
                        <a className="carousel-control-next" href="#demo" data-slide="next">
                            <span className="carousel-control-next-icon"/>
                        </a>
                    </div>
                </div>
            </Aux >
        )
    }
}

export default homepage;



// WEBPACK FOOTER //
// ./src/components/Homepage.js